module.exports = __webpack_public_path__ + "img/sokolinaya-gora.3b59db55.png";